export default __webpack_public_path__ + "static/media/Delish.0e40aeb7.svg";